import apiNetCore from '../services/apiNetCore';

export const getTransportadoras = async (user, empresasParceirasId) => {
  let transportadoras = [];

  const idPagadores = user.clientes_pagadores;

  if (idPagadores) {
    const config = {
      params: { idEmpresa: empresasParceirasId },
      paramsSerializer: ({ idEmpresa }) =>
        idEmpresa.map(id => `idEmpresa=${id}`).join('&'),
    };
    const { data } = await apiNetCore.get(
      '/EmpresaAts/BuscarEmpresas',
      empresasParceirasId && config
    );
    transportadoras = data;
  }
  return transportadoras;
};
